module.exports = __webpack_public_path__ + "img/super-easy-chili.7314ca30.jpg";